import { RESET_STATE } from 'services/auth/constants';

import {
    EQUIPMENT_SETS_SET,
    EQUIPMENT_SET_SET,
    EQUIPMENT_SET_DELETE_SUCCEEDED
} from './constants';
import { EquipmentSetsState, EquipmentSetsActions } from './types';

const initialState: EquipmentSetsState = {};

export default function (
    state: EquipmentSetsState = initialState,
    action: EquipmentSetsActions
): EquipmentSetsState {
    switch (action.type) {
        case EQUIPMENT_SETS_SET:
            return action.payload;
        case EQUIPMENT_SET_SET: {
            const { equipmentSetId, equipmentSet } = action.payload;
            return {
                ...state,
                [equipmentSetId]: equipmentSet
            };
        }
        case EQUIPMENT_SET_DELETE_SUCCEEDED: {
            const { equipmentSetId } = action.payload;

            const copy = { ...state };

            delete copy[equipmentSetId];

            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
